import SVGComponent from "../SVGComponent";
import ICONS from "../../../assets/Icons";

/**
 *
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void)} OnClickEventHandler
 * @param {object} props
 * @param {string} [props.icon]
 * @param {string} [props.iconColor]
 * @param {string} [props.title] Title to show. if this is not given the texts[0] is shown.
 * @param {string[] | string} props.texts Text to show.
 * - If this is a string then that string will be shown.
 * - If this is a list of strings then they will be shown as a bulleted list
 * @param {OnClickEventHandler} [props.onClick] - If this is given the card can be clickable
 */
export default function CommonAlertCard({
  icon,
  iconColor,
  texts,
  onClick,
  title,
}) {
  const processedTexts = Array.isArray(texts) ? texts : [texts];
  const getTextWithTitle = () => {
    if (title) {
      return (
        <>
          <div
            className={`flex flex-col ${processedTexts.length > 1 ? "gap-gap-sm" : "gap-gap-xs"}`}
          >
            <div className="text-font-sm font-semibold">{title}</div>
            <div className="text-font-xs">
              {processedTexts.length > 1 ? (
                <ol className="list-disc list-outside text-font-xs ml-margin-md">
                  {processedTexts.map((t) => (
                    <li className="mb-margin-sm">{t}</li>
                  ))}
                </ol>
              ) : (
                <>{processedTexts[0]}</>
              )}
            </div>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="text-font-xs">{processedTexts[0]}</div>
        </>
      );
    }
  };
  return (
    <>
      <div
        onClick={onClick || undefined}
        className={`w-full bg-emphasis rounded-border-radius-md p-padding-md relative z-z-index-content text-text-primary ${onClick ? "global-hover-white cursor-pointer" : ""} ${processedTexts.length > 1 ? "pb-padding-sm" : "pb-padding-md"}`}
      >
        <div className="flex flex-row justify-between items-start gap-gap-sm">
          <div className="flex flex-row gap-gap-sm items-center">
            <span>
              {iconColor ? (
                <>
                  <div className="flex-shrink-0 w-icon-md h-icon-md ">
                    <SVGComponent
                      url={
                        icon ||
                        "https://q2pay.in/new_assets/common/settings/error_with_white_circle.svg"
                      }
                      alt=""
                      color={iconColor}
                      height={"var(--icon-md)"}
                      width="var(--icon-md)"
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="w-icon-md h-icon-md flex-shrink-0 ">
                    <img
                      src={
                        icon ||
                        "https://q2pay.in/new_assets/common/settings/error_with_white_circle.svg"
                      }
                      alt=""
                    />
                  </div>
                </>
              )}
            </span>
            {getTextWithTitle()}
          </div>
          {onClick && (
            <div className="pt-padding-xs flex-shrink-0">
              <SVGComponent
                url={ICONS.ARROW_RIGHT_WHITE}
                height={"var(--icon-sm)"}
                width="var(--icon-sm)"
                color="var(--text-primary)"
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
